import React from 'react'
import AppContext from '../context/appContext'
import { useContext } from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { useEffect } from 'react'
import { useRef } from 'react'
// import { useContext } from 'react'
import { useState } from 'react'
const Transfer = () => {
    const appContext = useContext(AppContext)
    const params = useParams()
    const { to } = params

    const [transferInfo, setTransferInfo] = useState({ to: to || "", amount: 0 })

    const { authToken, createAccount, setAuthToken, getUser, userData, transferAmount,transferRef } = appContext
    function formatWalletAddress(address) {
        return address.slice(0, 6) + "..." + address.slice(-4);

    }

    function formatDate(isoString) {
        const date = new Date(isoString);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = String(date.getUTCFullYear()).slice(-2);

        return `${day}/${month}/${year}`;
    }

    const [transferUser, setTransferUser] = useState(null)

    useEffect(() => {

        getUserfromAddress()

    }, [transferInfo.to])

    const getUserfromAddress = async () => {

        // settheProductLoader(true)

        const url = `https://vertex-chain-backebd-ivory.vercel.app/api/auth/getuserfromwallet/${transferInfo.to}`
        const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Accept": "*",
            },

            // body: JSON.stringify({ username, password }), // body data type must match "Content-Type" header
        });

        // console.log(response);

        const data = await response.json(); // parses JSON response into native JavaScript objects
        if (!data.error) setTransferUser(data)
        else setTransferUser({ name: "User Not Found" })
        // console.log(data.map((e)=>{return e.id}))

    }

    if (transferInfo.amount < 0) {
        setTransferInfo({ amount: 0 })
    }

    console.log(userData);
    const transferModalRef = useRef(null)
    return (
        <div>
            <div className="px-md-5">
                <h1 className="text-light">Transfer Funds</h1>
            </div>
          
            <button ref={transferModalRef} type="button" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#exampleModal">
                Launch demo modal
            </button>

          
            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" data-bs-theme="dark" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5 text-light" id="exampleModalLabel">Transaction Confirmation</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                           <p className="text-light "><b>From</b>: {userData.walletAddress}</p>
                           <p className="text-light "><b>To</b>: {transferInfo.to}</p>
                           <p className="text-light"><b>Amount</b>: ${transferInfo.amount}</p>
                           <p className="text-light "><b>Transaction Fee:</b> 0% by VTC</p>
                        </div>
                        <div class="modal-footer">
                            <button ref={transferRef} type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button  type="button" onClick={() => transferAmount(transferInfo)} class="btn btn-light">Confirm</button>
                          
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-center  w-100 pt-5">
                <div className="d-flex flex-column input-group-custom px-md-5">
                    {transferUser && <>

                        <label className="text-light">Receiver Name</label>

                        <input required style={{ backgroundColor: "#23153c", color: "white", borderColor: "white" }} type="text" class="my-2 form-control" id="exampleFormControlInput1" disabled value={transferUser.name} placeholder="Referral Name" />

                    </>
                    }
                    <input value={transferInfo.to} onChange={(e) => setTransferInfo({ ...transferInfo, to: e.target.value })} style={{ backgroundColor: "#23153c", color: "white", borderColor: "white" }} type="text" class="my-2 form-control" id="exampleFormControlInput1" placeholder="User Wallet Address" />
                    <input value={transferInfo.amount} onChange={(e) => setTransferInfo({ ...transferInfo, amount: e.target.value })} style={{ backgroundColor: "#23153c", color: "white", borderColor: "white" }} type="number" class="my-2 form-control" id="exampleFormControlInput1" placeholder="Amount" />
                    <span className="text-light">{`Current Balance: $${userData.currentUserBalance}`}</span>
                    {transferUser ? <button disabled={!transferUser.walletAddress || transferInfo.amount > userData.currentUserBalance || transferInfo.amount == 0 || userData.walletAddress == transferInfo.to} onClick={() => transferModalRef.current.click()} className="btn btn-light w-100 my-2 ">Transfer</button> :
                        <button disabled={!transferUser || transferInfo.amount > userData.currentUserBalance || transferInfo.amount == 0 || userData.walletAddress == transferInfo.to} onClick={() => transferModalRef.current.click()} className="btn btn-light w-100 my-2 ">Transfer</button>}
                    <p className="text-light py-2">Please make sure the wallet address is correct. The amount will be transfered by clicking on the send button.</p>
                </div>
            </div>

            <div className="px-md-5">
                <h1 className="text-light pb-3">Transfer Statistics</h1>
                <div className="row">
                    <div className="col-sm-6 col-lg-6 col-12 my-2">
                        <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                            {/* <img src="..." class="card-img-top" alt="..."/> */}
                            <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                <p className='display-1 h1 text-light' style={{ fontWeight: "bold" }}>{`${userData.transfers.length}`}</p>
                            </div>
                            <div class="card-body d-flex flex-column">
                                <h2 class="card-title text-light">Total Transfers</h2>
                                <p class="card-text text-light">Total transfers sent and received</p>

                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-6 col-12 my-2">
                        <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                            {/* <img src="..." class="card-img-top" alt="..."/> */}
                            <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                <p className='display-1 h1 text-light' style={{ fontWeight: "bold" }}>{`$${Math.floor(userData.totalTransfer * 1000) / 1000}`}</p>
                            </div>
                            <div class="card-body d-flex flex-column">
                                <h2 class="card-title text-light">Transfers Amount</h2>
                                <p class="card-text text-light">Total transferred amount sent and received</p>

                            </div>
                        </div>
                    </div>
                </div>
                <h1 className="text-light my-4">Transfer History</h1>
                <div className="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                {/* <th style={{ backgroundColor: "#23153c", color: "white" }} scope="col">#</th> */}
                                <th style={{ backgroundColor: "#23153c", color: "white" }} scope="col">From</th>
                                <th style={{ backgroundColor: "#23153c", color: "white" }} scope="col">To</th>
                                <th style={{ backgroundColor: "#23153c", color: "white" }} scope="col">Amount</th>
                                <th style={{ backgroundColor: "#23153c", color: "white" }} scope="col">Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {userData.transfers.toReversed().map((e, i) => {
                                return <tr>
                                    {/* <th style={{ backgroundColor: "#23153c", color: "white" }} scope="row">{i+1}</th> */}
                                    <td style={{ backgroundColor: "#23153c", color: "white", fontWeight: "bold" }}>{formatWalletAddress(e.from)}</td>
                                    <td style={{ backgroundColor: "#23153c", color: "white" }}>{formatWalletAddress(e.to)}</td>
                                    <td style={{ backgroundColor: "#23153c", color: "white" }}>${e.amount}</td>
                                    <td style={{ backgroundColor: "#23153c", color: "white" }}>{formatDate(e.date)}</td>
                                </tr>
                            })
                            }

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default Transfer